"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var crypto_1 = __importDefault(require("crypto"));
var declarations_1 = require("./declarations");
var utils_1 = require("./utils");
var Medusa = /** @class */ (function () {
    function Medusa(options) {
        this.internalTargets = [];
        this.idList = [];
        var defaults = {
            targets: [],
            debug: true,
        };
        this.options = __assign(__assign({}, defaults), options);
        this.init();
    }
    Medusa.prototype.init = function () {
        Object.defineProperty(HTMLElement.prototype, '_medusaId', {
            value: '',
            configurable: true,
            enumerable: true,
            writable: true,
        });
        if (this.options.targets.length > 0)
            this.addTarget(this.options.targets);
    };
    Medusa.prototype.getTargetIndexFromId = function (targetId) {
        return this.internalTargets.findIndex(function (internalTarget) { return internalTarget.id === targetId; });
    };
    Medusa.prototype.emitEventCallback = function (internalTargetCreated, entry) {
        var optsEvent = {};
        optsEvent.detail = { targetId: internalTargetCreated.id, node: entry.target, isIn: entry.isIntersecting };
        var customEvent = new CustomEvent('medusa-intersection-triggered', optsEvent);
        (internalTargetCreated.emitGlobal ? window : entry.target).dispatchEvent(customEvent);
    };
    Medusa.prototype.createObserver = function (internalTargetCreated) {
        var _this = this;
        var callback = function (entries, observer) {
            entries.forEach(function (entry) {
                var target = entry.target;
                if (internalTargetCreated.mode === Medusa.MODE.ONCE && entry.isIntersecting) {
                    _this.pullFromTarget(internalTargetCreated.id, target);
                    if (internalTargetCreated.autoremove && internalTargetCreated.observedElements.length === 0) {
                        _this.removeTarget(internalTargetCreated.id);
                    }
                    if (internalTargetCreated.emitGlobal || internalTargetCreated.emitByNode) {
                        _this.emitEventCallback(internalTargetCreated, entry);
                    }
                    internalTargetCreated.callback(entry, observer);
                }
                else if (internalTargetCreated.mode !== Medusa.MODE.ONCE) {
                    if (internalTargetCreated.emitGlobal || internalTargetCreated.emitByNode) {
                        _this.emitEventCallback(internalTargetCreated, entry);
                    }
                    internalTargetCreated.callback(entry, observer);
                }
            });
        };
        internalTargetCreated.observerInstance = new IntersectionObserver(callback, internalTargetCreated.observerOptions);
        internalTargetCreated.observedElements.forEach(function (node) {
            if (internalTargetCreated.observerInstance === null)
                return;
            _this.pushToTarget(internalTargetCreated.id, node);
        });
    };
    Medusa.prototype.createInternalTarget = function (optionsTarget) {
        var internalTarget = {
            id: optionsTarget.id,
            observerInstance: null,
            observedElements: [],
            observerOptions: {
                root: optionsTarget.viewport,
                rootMargin: optionsTarget.offsets,
                threshold: optionsTarget.mode === Medusa.MODE.BYPIXELS
                    ? utils_1.thresholdsByPixels() : optionsTarget.threshold,
            },
            emitGlobal: optionsTarget.emitGlobal,
            emitByNode: optionsTarget.emitByNode,
            mode: optionsTarget.mode,
            callback: optionsTarget.callback,
            autoremove: optionsTarget.autoremove,
        };
        if (Array.isArray(optionsTarget.nodes)) {
            internalTarget.observedElements = optionsTarget.nodes;
        }
        else {
            internalTarget.observedElements = [];
            if (this.options.debug)
                console.warn("the node list for the target id: " + optionsTarget.id + " is invalid and converted to empty array");
        }
        // TODO fallback observer
        this.createObserver(internalTarget);
        return internalTarget;
    };
    Medusa.prototype.checkAddTarget = function (newTarget) {
        var defaultTarget = {
            viewport: null,
            nodes: [],
            threshold: 0,
            offsets: '0px 0px 0px 0px',
            callback: function () { },
            mode: Medusa.MODE.DEFAULT,
            emitGlobal: false,
            emitByNode: false,
            autoremove: false,
        };
        var partialTarget = __assign(__assign({}, defaultTarget), newTarget);
        if (this.idList.findIndex(function (id) { return id === newTarget.id; }) < 0) {
            this.internalTargets.push(this.createInternalTarget(partialTarget));
            this.idList.push(partialTarget.id);
        }
        else if (this.options.debug) {
            console.warn("The target id-key: '" + newTarget.id + "', already exist");
        }
    };
    Medusa.prototype.pushElementToTarget = function (node, indexTarget) {
        var _medusaId = node._medusaId;
        if (_medusaId === '') {
            node._medusaId = crypto_1.default.randomBytes(6).toString('hex');
            this.internalTargets[indexTarget].observerInstance.observe(node);
            this.internalTargets[indexTarget].observedElements.push(node);
        }
        else if (this.options.debug) {
            console.warn("node: " + node + ", already observed");
        }
    };
    Medusa.prototype.pullElementFromTarget = function (node, indexTarget, observer) {
        var _medusaId = node._medusaId;
        var elIndexToRemove = this.internalTargets[indexTarget].observedElements.findIndex(function (observedElement) { return observedElement._medusaId === _medusaId; });
        if (elIndexToRemove >= 0) {
            observer.unobserve(node);
            this.internalTargets[indexTarget].observedElements.splice(elIndexToRemove, 1);
            node._medusaId = '';
        }
        else if (this.options.debug) {
            console.warn('The element isn\'t observed');
        }
    };
    Medusa.prototype.getTargetFromId = function (targetId) {
        var indexTarget = this.getTargetIndexFromId(targetId);
        var target;
        if (indexTarget >= 0) {
            target = this.internalTargets[indexTarget];
        }
        else {
            target = null;
            if (this.options.debug)
                console.warn('The target doesn\'t exist');
        }
        return target;
    };
    Medusa.prototype.addTarget = function (newTargets) {
        var _this = this;
        if (Array.isArray(newTargets))
            newTargets.forEach(function (newTarget) { return _this.checkAddTarget(newTarget); });
        else if (typeof newTargets === 'object')
            this.checkAddTarget(newTargets);
        else if (this.options.debug)
            console.warn("Target uncorrect");
    };
    Medusa.prototype.removeTarget = function (targetId) {
        var indexTargetToRemove = this.getTargetIndexFromId(targetId);
        if (indexTargetToRemove >= 0) {
            this.clearTarget(targetId);
            var currentTarget = this.internalTargets[indexTargetToRemove];
            currentTarget.observerInstance.disconnect();
            currentTarget.observerInstance = null;
            this.internalTargets.splice(indexTargetToRemove, 1);
            this.idList = this.idList.filter(function (id) { return id !== targetId; });
            this.internalTargets = this.internalTargets.filter(function (target) { return target.id !== targetId; });
        }
        else if (this.options.debug) {
            console.warn('The targets id doesn\'t exist');
        }
    };
    Medusa.prototype.clearTarget = function (targetId) {
        var indexTargetToClear = this.getTargetIndexFromId(targetId);
        if (indexTargetToClear >= 0) {
            var targetObservedElements = this.internalTargets[indexTargetToClear].observedElements;
            if (targetObservedElements.length >= 0)
                this.pullFromTarget(targetId, targetObservedElements);
        }
        else if (this.options.debug) {
            console.warn("the target id: " + targetId + ", is already clear");
        }
    };
    Medusa.prototype.clearAllTargets = function () {
        var _this = this;
        this.idList.forEach(function (targetId) { return _this.clearTarget(targetId); });
    };
    Medusa.prototype.pushToTarget = function (targetId, elsToAdd) {
        var _this = this;
        var indexTarget = this.getTargetIndexFromId(targetId);
        if (indexTarget >= 0) {
            if (Array.isArray(elsToAdd))
                elsToAdd.forEach(function (node) { return _this.pushElementToTarget(node, indexTarget); });
            else
                this.pushElementToTarget(elsToAdd, indexTarget);
        }
        else if (this.options.debug) {
            console.warn('The targets id doesn\'t exist');
        }
    };
    Medusa.prototype.pullFromTarget = function (targetId, elsToRemove) {
        var indexTarget = this.getTargetIndexFromId(targetId);
        if (indexTarget >= 0) {
            var observer = this.internalTargets[indexTarget].observerInstance;
            if (Array.isArray(elsToRemove)) {
                for (var index = elsToRemove.length - 1; index >= 0; index--) {
                    var node = elsToRemove[index];
                    this.pullElementFromTarget(node, indexTarget, observer);
                }
            }
            else {
                this.pullElementFromTarget(elsToRemove, indexTarget, observer);
            }
        }
        else if (this.options.debug) {
            console.warn('The targets id doesn\'t exist');
        }
    };
    Medusa.MODE = declarations_1.MODE;
    Medusa.THRESHOLD = declarations_1.THRESHOLD;
    return Medusa;
}());
exports.default = Medusa;
